export const obterCodigoConvenio = (item) => {
  if (typeof item === "string") return item.trim();
  return String(item?.convenio ?? "").trim();
};

const obterNomeComercialPorCodigo = (codigo) => {
  const codigoNormalizado = String(codigo ?? "").trim().toUpperCase();

  return /^AMIL(?:[-. ]|$)/.test(codigoNormalizado) ? "AMIL" : "";
};

export const obterNomeConvenio = (item) => {
  const codigo = obterCodigoConvenio(item);
  const nomeComercialPorCodigo = obterNomeComercialPorCodigo(codigo);

  if (typeof item === "string") {
    return nomeComercialPorCodigo || codigo;
  }

  const nome = String(item?.nome_convenio ?? item?.nomeConvenio ?? "").trim();
  return nomeComercialPorCodigo || nome || codigo;
};

export const obterLabelConvenio = (item) => {
  const codigo = obterCodigoConvenio(item);
  const nome = obterNomeConvenio(item);

  if (!codigo || codigo === nome) return nome || codigo;
  return `${nome} (${codigo})`;
};

const normalizarTextoConvenio = (valor) =>
  String(valor ?? "")
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");

export const expandirConveniosPorNome = (opcoes, selecionado) => {
  if (!selecionado) return [];

  const nomeSelecionado = normalizarTextoConvenio(
    obterNomeConvenio(selecionado),
  );
  const correspondentes = (Array.isArray(opcoes) ? opcoes : []).filter(
    (item) =>
      normalizarTextoConvenio(obterNomeConvenio(item)) === nomeSelecionado,
  );

  if (!correspondentes.length) return [selecionado];

  const codigosAdicionados = new Set();
  return correspondentes.filter((item) => {
    const codigo = obterCodigoConvenio(item);
    if (!codigo || codigosAdicionados.has(codigo)) return false;

    codigosAdicionados.add(codigo);
    return true;
  });
};

export const deduplicarConveniosPorNome = (opcoes) => {
  const nomesAdicionados = new Set();

  return (Array.isArray(opcoes) ? opcoes : []).filter((item) => {
    const nome = normalizarTextoConvenio(obterNomeConvenio(item));

    if (!nome || nomesAdicionados.has(nome)) return false;

    nomesAdicionados.add(nome);
    return true;
  });
};

export const filtrarConvenios = (opcoes, estado) => {
  const termo = normalizarTextoConvenio(estado?.inputValue);

  if (!termo) return opcoes;

  const correspondencias = opcoes.filter((item) =>
    [obterNomeConvenio(item), obterCodigoConvenio(item)].some((valor) =>
      normalizarTextoConvenio(valor).includes(termo),
    ),
  );

  const correspondenciasExatas = correspondencias.filter((item) =>
    [obterNomeConvenio(item), obterCodigoConvenio(item)].some(
      (valor) => normalizarTextoConvenio(valor) === termo,
    ),
  );

  return correspondenciasExatas.length > 0
    ? correspondenciasExatas
    : correspondencias;
};
